import './WorkdayJobs.scss'

import { useFilterLogic } from './useFilterLogic'
import { WorkdayJobsContext } from './WorkdayJobsContext'
import WorkdayJobsFilter from './WorkdayJobsFilter/WorkdayJobsFilter'
import { WorkdayJobsProps } from './WorkdayJobsProps'
import Table from './WorkdayJobsTable/Table'

export default function WorkdayJobs({
  resultlist,
  hidelocation,
  hidejobtype,
  hidetypeofcontract,
  hideexperience,
  hidejobfunction,
  hidebusinessunit,
  hideproductgroup,
}: WorkdayJobsProps) {
  const {
    filters,
    filteredJobs,
    visibleJobs,
    visibleCount,
    tempSelections,
    openDropdown,
    handleLoadMore,
    getOptions,
    getAvailableOptions,
    toggleDropdown,
    toggleOption,
    resetField,
    applyFilter,
    resetFilters,
    removeFilter,
  } = useFilterLogic(resultlist)

  const headerLabels = {
    applyNowUrl: 'Apply',
    businessUnit: 'Business Unit',
    experience: 'Experience',
    jobFunction: 'Job Function',
    jobType: 'Job Type',
    primaryLocation: 'Location',
    path: 'Path',
    productGroup: 'Product Group',
    title: 'Title',
    typeOfContract: 'Contract Type',
  }
  const filterFields = ['primaryLocation', 'jobType', 'typeOfContract', 'experience', 'jobFunction', 'businessUnit', 'productGroup']

  return (
    <WorkdayJobsContext.Provider
      value={{
        openDropdown,
        tempSelections,
        filters,
        toggleDropdown,
        hidelocation,
        hidejobtype,
        hidetypeofcontract,
        hideexperience,
        hidejobfunction,
        hidebusinessunit,
        hideproductgroup,
        filteredJobscount: filteredJobs.length,
        resetFilters,
        removeFilter,
      }}
    >
      <WorkdayJobsFilter
        getOptions={getOptions}
        getAvailableOptions={getAvailableOptions}
        headerLabels={headerLabels}
        filterFields={filterFields}
        resetField={resetField}
        applyFilter={applyFilter}
        toggleOption={toggleOption}
      />
      <Table visibleJobs={visibleJobs} visibleCount={visibleCount} handleLoadMore={handleLoadMore} />
    </WorkdayJobsContext.Provider>
  )
}
